import router from '@/router';
import isGuestRoute from './isGuestRoute';
import recognition from './recognition';

router.beforeEach((to, from, next) => {
  if (!isGuestRoute(to.path) && !recognition.isAuthenticated()) {
    next(`/login?target=${encodeURIComponent(to.fullPath)}`);
  } else {
    next();
  }
});
